import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { FlexRow } from "@similarweb/ui-components";
import { setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, navigation } = colorsPalettes;

const Y_AXIS_PADDING = 12;

/* `body` is `overflow: hidden !important`, so the document itself never scrolls and the
   page has to own its scrolling. The inset comes from padding rather than margin so the
   box spans the full viewport and its scrollbar sits against the window edge, reading as
   a page scrollbar instead of a bar floating inside the content. */
export const MarketBuilderWrapper = styled(FlexColumn)`
    padding: ${Y_AXIS_PADDING}px 40px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
`;

export const BackButton = styled(IconButton)`
    margin: 0 0 12px -16px;
    min-height: 37px;
`;

export const TopRow = styled(FlexRow)`
    justify-content: space-between;
    align-items: center;
`;

export const HeaderWrapper = styled.div`
    margin-bottom: 24px;
`;

export const Title = styled.div`
    ${setFontVariant("h4", carbon[500])}
    line-height: 32px;
    margin-bottom: 4px;
`;

export const Subtitle = styled.div`
    ${setFontVariant("body2", carbon[300])}
    line-height: 20px;
`;

export const YourListWrapper = styled.div`
    width: 25%;
    border: 1px solid ${navigation["BORDER_DARK_1"]};
    margin: 24px;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 24px;
`;

export const TabsContainer = styled.div`
    width: 75%;
`;

export const ContentWrapper = styled(Box)`
    display: flex;
    width: 100%;
    height: initial;
    /* Must not shrink: otherwise the columns compress out of the viewport instead of
       letting the page scroll, which puts the save button out of reach. */
    flex: 1 0 auto;
`;

export const SaveBtnContainer = styled(FlexRow)``;

export const StyledList = styled.ul`
    margin-left: 20px;
    margin-bottom: 0;
    list-style-type: disc;
`;

export const StyledListItem = styled.li``;
